<template>
  <div class="index container">
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
    }
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: '/join-game',
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-weight: normal;
}
button {
  margin-bottom: 20px;
}
create-game {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue